import React, { useEffect, } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap'
import copy from 'clipboard-copy';

function Data(props) {
    const { socket, serial, setLoading, formData } = props;

    const copyToClipboard = (text) => {
        copy(text).then(() => {
            alert('Copiado para área de transferência!')
        }).catch(err => {
            console.error('Erro ao copiar texto para a área de transferência: ', err);
        });
    };

    useEffect(() => {
        const handleGetData = () => {
            if (!serial) {
                return
            }
            setLoading(true)
            socket.send(
                JSON.stringify({
                    type: 'message',
                    room: serial,
                    content: {
                        command: 'web_browser',
                        parameters: {
                            value: 'get_data',
                            page: 'data'
                        }
                    },
                })
            );
        };
        handleGetData()
    }, [serial])

    return (
        <Card className='p-3' style={{ background: '#f4f4f4', textAlign: "initial" }}>
            <Row>
                <h3>JSON:</h3>
                <Col>
                    {formData?.json ? (
                        <div id="json-container">
                            <pre>{JSON.stringify(formData.json, null, 2)}</pre>
                            <Button
                                className="col-sm-3"
                                variant="success"
                                onClick={() => copyToClipboard(JSON.stringify(formData.json, null, 2))}
                            >
                                Copiar JSON
                            </Button>
                        </div>
                    ) : (
                        <h5>Sem dados</h5>
                    )}
                </Col>
            </Row>

            <hr />
            <h3>TXT:</h3>
            <Row>
                <Col>
                    {formData?.txt ? (
                        <div id="json-container">
                            <pre>{formData?.txt}</pre>
                            <Button
                                className='col-sm-3'
                                variant="success"
                                onClick={() => { copyToClipboard(formData?.txt) }}
                            >
                                Copiar Txt
                            </Button>
                        </div>
                    ) : (<h5>Sem dados</h5>)
                    }
                </Col>
            </Row>

            <hr />
            <h3>JSON_b64:</h3>
            <Row>
                <Col>
                    {formData?.json_b64 ? (
                        <div id="json-container">
                            <pre>{formData?.json_b64}</pre>
                            <Button
                                className='col-sm-3'
                                variant="success"
                                onClick={() => { copyToClipboard(formData?.json_b64) }}
                            >
                                Copiar Json_b64
                            </Button>
                        </div>
                    ) : (<h5>Sem dados</h5>)
                    }
                </Col>
            </Row>

            <hr />
            <h3>TXT_b64:</h3>
            <Row>
                <Col>
                    {formData?.txt_b64 ? (
                        <div id="json-container">
                            <pre>{formData?.txt_b64}</pre>
                            <Button
                                className='col-sm-3'
                                variant="success"
                                onClick={() => { copyToClipboard(formData?.txt_b64) }}
                            >
                                Copiar Txt_b64
                            </Button>
                        </div>
                    ) : (<h5>Sem dados</h5>)
                    }
                </Col>
            </Row>
        </Card >
    );
}

export default Data;
